import Layout from "../components/Layout";
import { MiDocumento } from "../components/DocumentosMensuales/MiDocumento";

const MiDocumentoMensual = () => (
    <>
        <Layout />
        <div className="bg-slate-100 min-h-screen w-full overflow-y-auto">
            <MiDocumento />
        </div>
    </>
);

export default MiDocumentoMensual;
